<template>
    <section class="about-video content-section container px-3">
        <h2 class="content-section-title">COMPANY VIDEOS</h2>
        <VideoPlayer :videos="videos" />
    </section>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'

export default {
    components: {VideoPlayer},
    data() {
        return {
            videos: [
                { type:'ad', brand: 'st', title: '【 佰視佳雨刷，把安全帶回家 】Scan Top Group', ytId: 'GK0zu8Cuuj8'},
                { type:'ad', brand: 'st', title: '【 Windshield Wiper blade 】Scan Top Group - UPC Factory', ytId: '1U7_s5XpY6s'},
                { type:'ad', brand: 'st', title: '【雨刷製造，匠人精神】金頂集團 - 鎮威雨刷製造廠', ytId: 'hLHfkokai10'},
            ],
        }
    },
}
</script>

<style>

</style>
